import { jsx as _jsx } from "react/jsx-runtime";
import { Card } from '@coolblue-development/freddy';
import { EntranceDisplay, HemingwayLinkType } from '../../../../types.js';
import { Pill } from '../../Pills/index.js';
import { getLinkFollowType, getPropertyFromLink } from '../../utils/index.js';
import EntranceCardFooterLinks from './EntranceCardFooterLinks.js';
import EntranceCardMedia from './EntranceCardMedia.js';
import EntranceCardTitle from './EntranceCardTitle.js';
import EntranceProCon from './EntranceProCon.js';
export const Entrance = ({ entrance, displayStyle = EntranceDisplay.Default, onClick, imageLoadingStrategy = 'lazy', imageSizes, ...restProps }) => {
    var _a, _b, _c;
    if (!entrance.link) {
        return null;
    }
    if (displayStyle === EntranceDisplay.Pill) {
        return _jsx(Pill, { entrance: entrance, ...restProps });
    }
    const cardRestProps = {
        ...(displayStyle === EntranceDisplay.WithDescription && {
            description: entrance.description,
        }),
        ...(displayStyle === EntranceDisplay.WithProCon && {
            description: _jsx(EntranceProCon, { entrance: entrance }),
        }),
        ...(entrance.links && {
            footerActions: _jsx(EntranceCardFooterLinks, { entrance: entrance }),
        }),
        onClick,
    };
    const title = getPropertyFromLink('title', entrance.link);
    const url = getPropertyFromLink('absoluteUrl', entrance.link);
    const rel = getLinkFollowType(entrance.link);
    const target = entrance.link.__typename === HemingwayLinkType.External ? '_blank' : undefined;
    return (((_b = (_a = entrance.image) === null || _a === void 0 ? void 0 : _a.image) === null || _b === void 0 ? void 0 : _b.id) && (_jsx(Card, { fullHeight: true, header: _jsx(EntranceCardMedia, { imageId: entrance.image.image.id, altText: (_c = entrance.image.label) !== null && _c !== void 0 ? _c : '', loading: imageLoadingStrategy, imageSizes: imageSizes }), title: _jsx(EntranceCardTitle, { displayStyle: displayStyle, children: title }), href: url, linkProps: { rel, target }, ...cardRestProps })));
};
//# sourceMappingURL=Entrance.js.map